import React, { useState } from 'react'
import ActionCard from '../ActionCard'
import useNavigation from 'hooks/useNavigation'
import { Text } from '@chakra-ui/react'
import {
  BoxDirectAccess,
  ButtonContainer,
  ModalDescription,
  ModalButton
} from './styles'
import { useScreenSizes } from 'hooks/useScreenSizes'
import useHasSisa from '@qirapagos/lib/hooks/useHasSisa'
import { useAppSelector } from 'hooks/redux'
import { CustomModal } from 'components'
import useHasOnboardingComplete, {
  StatusOnboardingLabel
} from '@qirapagos/lib/hooks/useHasOnboardingComplete'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

interface IDataActionCards {
  icon: 'grains' | 'newTransfer' | 'helpCenter' | 'extranetLink' | 'debin'
  title: string
  onPress: () => void
  isDisabled?: boolean
}

const CONTACT_PHONE_KEY = 'qirapagos-server.settings.contactPhoneNumber'

const DirectAccess: React.FC = () => {
  const { onNavigate } = useNavigation()
  const { multiEnterprise } = useAppSelector(state => state.auth)
  const [isOpen, setIsOpen] = useState(false)
  const hasOnboardingComplete = useHasOnboardingComplete()
  const phoneNumber = useAppSelector(
    state => state.settings.data[CONTACT_PHONE_KEY] || ''
  )
  const normalizedPhone = (phoneNumber || '').replace(/\D/g, '')
  const whatsappLink = normalizedPhone ? 'https://wa.me/' + normalizedPhone : ''

  const { isTabletDisplayOrLower } = useScreenSizes()
  const hasSisa = useHasSisa()
  const { isRepresentative, represented } = useSelector(
    (state: RootState) => state.representation
  )
  const notSisaNotRepresented = !hasSisa && !represented?.length
  const representativeNotSisaNotRepresented =
    isRepresentative && notSisaNotRepresented
  const representedNotSisa = !isRepresentative && !hasSisa

  const cardWidth = isTabletDisplayOrLower ? 'calc(50% - 1vw)' : '6.7vw'
  const cardHeight = isTabletDisplayOrLower ? '9vh' : '11.7vh'

  const dataActionCards: IDataActionCards[] = [
    {
      icon: 'grains',
      isDisabled: representativeNotSisaNotRepresented || representedNotSisa,
      title: 'Nueva operación',
      onPress: () =>
        onNavigate('/content/grains/', {
          title: 'Granos',
          hasBackArrow: true
        })
    },
    {
      icon: 'newTransfer',
      isDisabled: hasOnboardingComplete === StatusOnboardingLabel.PENDING,
      title: 'Nueva transferencia',
      onPress: () =>
        onNavigate('/content/your-account/new-transfer', {
          title: 'Nueva transferencia',
          hasBackArrow: true
        })
    },
    {
      icon: 'helpCenter',
      title: 'Centro de ayuda',
      onPress: () => window.open(whatsappLink, '_blank')
    },
    {
      icon: 'extranetLink',
      title: 'Clientes ALZ AGRO',
      onPress: () => {
        setIsOpen(true)
      },
      isDisabled: multiEnterprise[0]?.url === null
    }
  ]

  return (
    <>
      <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Saliendo de Qira"
      >
        <ModalDescription>
          <Text>Serás redireccionado a la sección</Text>
          <Text>de Clientes de ALZ AGRO</Text>
        </ModalDescription>
        <ButtonContainer>
          <ModalButton
            onPress={() => {
              setIsOpen(false)
              window.open(multiEnterprise[0]?.url, '_blank')
            }}
          >
            Continuar
          </ModalButton>
          <ModalButton secondary onPress={() => setIsOpen(false)}>
            Cancelar
          </ModalButton>
        </ButtonContainer>
      </CustomModal>
      <BoxDirectAccess>
        {dataActionCards.map((card) => (
          <ActionCard
            icon={card.icon}
            title={card.title}
            onPress={card.onPress}
            width={cardWidth}
            height={cardHeight}
            flexDirection="column"
            isDisabled={card.isDisabled}
          />
        ))}
      </BoxDirectAccess>
    </>
  )
}

export default DirectAccess
